import styled from "styled-components";

// Passed to ReactTableTrademo as `StyledComponent` (same approach as CustomStylesWorkspaceTable).
// Values follow the Zeplin "AI_Recommendations_Updated_Oct26" screen: 44px rows, 10px/12px cell padding,
// 1px #eaecf0 grid, #f9fafb header with 14/20 medium text, 64px checkbox column.
// The checkbox itself keeps ReactTableTrademo's default .datatable-checkbox styling.
export const RecommendationsTableStyles = styled.div`
  margin-bottom: 0 !important;
  font-family: "Inter", sans-serif;

  .new-trademo-table-container {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    border-radius: 0;
    ::-webkit-scrollbar {
      height: 6px;
    }
  }

  table {
    margin-bottom: 0;
    table-layout: fixed;
    border-spacing: 0;
    border-collapse: collapse;
    background: #fff;

    th,
    td {
      margin: 0;
      padding: 10px 12px !important;
      border: 1px solid #eaecf0 !important;
      vertical-align: middle !important;
    }

    thead {
      th {
        height: 44px;
        background: #f9fafb !important;
        color: #101828;
        font-size: 14px !important;
        line-height: 20px;
        font-weight: 500 !important;
        letter-spacing: -0.07px;
        white-space: nowrap;
        span {
          margin: 0;
        }
        /* Let header content span the cell (criteria filter icon sits on the right edge). */
        > span {
          display: block;
          width: 100%;
        }
      }
    }

    tbody tr {
      font-size: 14px !important;
      line-height: 20px;
      :hover,
      :hover td {
        background-color: #fff !important;
      }
      td {
        height: 44px;
        background: #fff;
        color: #101828 !important;
        font-weight: 400 !important;
        letter-spacing: -0.07px;
      }
    }

    /* Checkbox column: 64px wide (design). */
    thead th:first-child,
    tbody td:first-child {
      width: 64px !important;
      min-width: 64px !important;
      max-width: 64px !important;
    }

    /* Company column takes the remaining width; the rest keep their design widths. */
    thead th:nth-child(2) {
      width: auto !important;
      max-width: none !important;
    }

    /* Default ReactTableTrademo checkbox (copied from its Styles, as CustomStylesWorkspaceTable does). */
    .datatable-checkbox {
      font-size: 18px;
      cursor: pointer;
      padding: 0px;
      margin-top: -1px;
      vertical-align: middle;
      position: relative;
      :after {
        left: -1.05px;
      }
    }
  }

  .trademo-table-pagination-container {
    border-top: none;
  }
`;
